let LocationCode = {
    ALL: -2,
    NOT_LOADING: -1,
    PNU: 0,
    KSU: 1,
    text: ["부산대점", "경성대점",]
}
export default LocationCode;
